import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import Select from 'react-select'
import { decodeData } from '../../Constants/constants';
class CalendarWeeklyOff extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            calendar_weekly_off_id: 0,
            calendar_id: '',
            calendar_weekly_off_day: '',
            rows: [],
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            postLoading: false,
            get_calendars_rows: [],
            decodedData: [],

        };
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
            this.GetCalendarFestivals();
        })
    }
    componentDidUpdate(prevProps, prevState) {
          if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
              const { permissions } = this.context;
              if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                  this.setState({ decodedData });
                }
              } else {
                console.warn("Permissions not yet available. Retrying...");
              }
          }
      }
    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    GetCalendarFestivals = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetCalendars`, { params: { limit: 1000, page: this.state.page }, headers })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        get_calendars_rows: data.data.map((row) => ({
                            value: row.calendar_id,
                            label: (
                                <span>
                                    {row.from_date} <i className="ri-arrow-left-right-line" /> {row.to_date}
                                </span>
                            ),
                        }))
                    }));
                }
            });
    }

    handleSelect = (selectedOption) => {
        this.setState({
            calendar_id: selectedOption.value
        });
    };

    GetInfo = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetCalendarWeeklyOffInfo?calendar_weekly_off_id=${this.state.calendar_weekly_off_id}`, { headers }).then((response) => {
            const { data, success } = response.data;
            if (success === true) {
                this.setState(
                    {
                        calendar_weekly_off_day: data[0].calendar_weekly_off_day,
                        calendar_id: data[0].calendar_id,

                    }
                )
            }
        });
    }
    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetCalendarWeeklyOffs`, { params: { limit: this.state.limit, page: this.state.page }, headers }).then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        const formData = {
            calendar_id: this.state.calendar_id,
            calendar_weekly_off_day: this.state.calendar_weekly_off_day,
        };

        
        if (this.state.calendar_weekly_off_id !== 0) {
            formData.calendar_weekly_off_id = this.state.calendar_weekly_off_id;
        }

        axios
            .post(`${apiURL}Masters/CreateCalendarWeeklyOff`, formData, { headers })
            .then((response) => {
                const { success } = response.data;
                if (success === true) {
                    this.setState({
                        calendar_weekly_off_day: '',
                        calendar_weekly_off_id: 0,
                        calendar_id: 0,

                    })

                    this.setState({ loadingList: true }, (prevState) => {
                        this.GetList();
                    })
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? 'success' : 'error',
                        timer: 2000,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    })
                } else {
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? 'success' : 'error',
                        timer: 2000,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    })
                    this.setState({ loadingList: true }, (prevState) => {
                        this.GetList();
                    })
                }

            })
    };
    resetForm = () => {
        this.setState({
            calendar_weekly_off_id: 0,
            calendar_id: 0,
            calendar_weekly_off_day: '',
        })

    }

    handleDelete = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true });
                const formData = {
                    calendar_weekly_off_id: id
                };
                axios
                    .post(`${apiURL}Masters/DeleteCalendarWeeklyOff`, formData, { headers })
                    .then((response) => {
                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            timer: 1000,
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        });
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                            })
                        }
                    })
                    .catch((error) => {

                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error'
                        })
                    });
            }
        });
    }

    handlePrev = (ev) => {

        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleNext = () => {

        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleChange = (e) => {

        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetList();
        });
    }

    render() {
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Calendar Weekly Off`} primary={`Home`} />
                        <div className="row">
                            <div className="col-md-5">
                                <div className="card">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">Calendar Weekly Off</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form onSubmit={this.handleSubmit} className="row">
                                                    <div className="col-md-12 mt-3 mb-3">
                                                        <label>Select Calendar</label>
                                                        <Select onChange={this.handleSelect} hint={`Select Calendar`} value={this.state.calendar_id ? this.state.get_calendars_rows.find(option => option.value === this.state.calendar_id) : null} options={this.state.get_calendars_rows} />
                                                    </div>

                                                    <div className="col-md-12 mt-3">
                                                        <TextBox type='text' id='calendar_weekly_off_day' name='calendar_weekly_off_day' value={this.state.calendar_weekly_off_day} label='Weekly Off days' hint='Enter Weekly Off days' change={this.handleInputChange} />

                                                    </div>
                                                    <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                        {
                                                            this.state.calendar_weekly_off_id !== 0 ? <SubmitBtn icon={`ri-save-line`} text={`Update`} type={`primary`} status={this.state.status} /> : <SubmitBtn text={`Save`} type={`primary`} icon={`ri-save-line`} />

                                                        }

                                                        {
                                                            this.state.calendar_weekly_off_id !== 0 ? <button style={{ float: 'right' }} type="button" className={`btn btn-light right btn-label`} onClick={() => this.resetForm()} ><i className={` ri-arrow-right-line label-icon align-middle fs-16 ms-2`} />{" "}New</button> : <div></div>

                                                        }
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className='card'>
                                    <div className="col-md-12">
                                        <table className={`table table-bordered table-stripped`}>
                                            <thead className='table-light'>
                                                <tr>

                                                    <th>Calendar </th>
                                                    <th>Calendar Weekly Off Day's</th>
                                                    <th width={120}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.rows.map((row) => {
                                                        return <tr key={row.calendar_weekly_off_id}>
                                                            <td>{row.calendar_label[0].calendar_from_date}<i className="ri-arrow-left-right-line mx-2" />{row.calendar_label[0].calendar_to_date}</td>
                                                            <td>{row.calendar_weekly_off_day}</td>

                                                            <td className='d-flex justify-content-around'>
                                                                <button type='button' onClick={() => this.setState({ calendar_weekly_off_id: row.calendar_weekly_off_id }, (prevState) => this.GetInfo())} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>
                                                                <button onClick={() => this.handleDelete(row.calendar_weekly_off_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>
                                                            </td>
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                            <tfoot className='table-light'>
                                                <tr>
                                                    <th colSpan={5} >
                                                        <div className="d-flex justify-content-between" >
                                                            <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                            <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                                {
                                                                    <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                                }
                                                            </div>
                                                            <div className='col-md-2'>
                                                                <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                                    {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                                        <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </tfoot>

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }; s
}
export default withRouter(CalendarWeeklyOff);



